import { AsyncStateStatus } from '../root.types'

/**
 * Redux Actions Company
 * @typedef DocumentsTypes
 * @namespace DocumentsTypes
 * @category React
 * @subcategory Redux / Types
 */

/**
 * Typing constant of action identifiers.
 * </br>
 * The action identifiers are:
 * <pre>
 *     <ul>
 *         <li>@documents/documentsRequest</li>
 *         <li>@documents/itensRequest</li>
 *      </ul>
 * </pre>
 * @memberof DocumentsTypes
 * @function
 * @category React
 * @subcategory Redux / Types
 */
export enum DocumentsTypes {
    DOCUMENTS_REQUEST = '@documents/documentsRequest',
    DOCUMENTS_CANCEL = '@documents/documentsCancel',
    ITENS_REQUEST = '@documents/itensRequest',
    DANFE_REQUEST = '@documents/danfeRequest'
}

export interface IActionDocumentsRequest {
    readonly type?: string
    readonly access_key?: string,
    readonly start_date?: string,
    readonly end_date?: string,
    readonly issuer_document?: string,
    readonly recipient_document?: string
    readonly emitIp?: string,
    readonly emitPort?: string
}

/**
 * @memberof CompanyTypes
 * @interface IRequsetState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {string} cnpj
 * @property {string} razaoSocial
 * @property {Array} result
 */
export interface IRequsetState {
    readonly status: AsyncStateStatus,
    readonly result: any[],
    readonly type: string
}

/**
 * @memberof CompanyTypes
 * @interface IItensState
 * @category React
 * @subcategory Redux / Types
 * @property {AsyncStateStatus} status
 * @property {Array} notas
 */
export interface IItensState {
    readonly status: AsyncStateStatus
    readonly notas: any[]
}

export interface IDanfeState {
    readonly status: AsyncStateStatus,
}

/**
 * @memberof CompanyTypes
 * @interface DocumentsState
 * @category React
 * @subcategory Redux / Types
 * @property {IRequsetState} request
 * @property {IItensState} itens
 */
export interface DocumentsState {
    request: IRequsetState,
    itens: IItensState
    danfe: IDanfeState
}
